import * as React from 'react';

// UTILS
import { listenForOutsideClicks } from '../utils';

// ICONS
import { ReactComponent as ChevronDown } from '../assets/svg/chevron-down.svg';

interface SingleSelectTypes {
	name?: string;
	placeholder?: string;
	options?: { label?: string; value?: string }[];
	value?: string;
	onChange?: any;
	isDisabled?: boolean;
	className?: string;
}

export const SingleSelect: React.FC<SingleSelectTypes> = ({
	name = '',
	placeholder = 'Please select...',
	options,
	value,
	isDisabled = false,
	onChange,
	className
}) => {
	const [selectedValue, setSelectedValue] = React.useState(value === undefined ? value : '');

	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const elementRef = React.useRef(null);

	listenForOutsideClicks(elementRef, isOpen, setIsOpen);

	const toggleOpen = (open?: boolean) => {
		if (open !== undefined) {
			setIsOpen(open);
		} else {
			setIsOpen(!isOpen);
		}
	};

	const handleChange = (value: string | undefined) => {
		if (value !== undefined) {
			toggleOpen(false);

			const selectedValue = value.toString();

			setSelectedValue(selectedValue);

			if (onChange) {
				onChange(selectedValue);
			}
		}
	};

	React.useEffect(() => {
		if (value !== undefined) {
			setSelectedValue(value);
		}
	}, [value]);

	return (
		<div className={`single-select ${isOpen ? 'open' : null} ${isDisabled ? 'disabled' : null}`} ref={elementRef}>
			<div
				className={`single-select-display form-control ${isOpen ? 'active' : null}`}
				onClick={() => toggleOpen()}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						toggleOpen();
					}

					if (e.key === 'Escape') {
						toggleOpen();
					}
				}}
				tabIndex={0}
			>
				{!selectedValue ? (
					<span className="placeholder">{placeholder}</span>
				) : (
					options &&
					options.length &&
					options
						.filter((option) => selectedValue === option.value || '')
						.map((option, index, options) => (
							<React.Fragment key={'selected-' + index}>
								<span>{option.label}</span>
								{index !== options.length - 1 && ','}
							</React.Fragment>
						))
				)}
				<ChevronDown />
			</div>

			{options && options.length > 0 && isOpen ? (
				<div className={`single-select-options ${className}`}>
					<ul>
						{options.map((option, index) => {
							return (
								<li
									key={'option-' + option.value}
									onClick={() => handleChange(option.value)}
									tabIndex={0}
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											handleChange(option.value);
										}

										if (e.key === 'Escape') {
											toggleOpen();
										}
									}}
								>
									{option.label}
								</li>
							);
						})}
					</ul>
				</div>
			) : null}
		</div>
	);
};

export default SingleSelect;
